import { KdsModal, KdsText } from "@kazaar-platform/design-system";
import { useTranslate } from "@tolgee/react";
import { type ModalCancelRetroplanningProps } from "./ModalCancelRetroplanning.types";

export const ModalCancelRetroplanning = ({
  isOpen,
  onQuit,
  onOpenChange,
}: ModalCancelRetroplanningProps) => {
  const { t } = useTranslate();

  return (
    <KdsModal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      size="sm"
      dialogProps={{
        dialogHeaderProps: {
          title: t("oms.addRetroplanning.modalCancel.title"),
        },
        content: (
          <KdsText>{t("oms.addRetroplanning.modalCancel.subtitle")}</KdsText>
        ),
        dialogFooterProps: {
          buttonProps: [
            {
              children: t("buttons.cancel"),
              variant: "ghost",
              color: "neutral",
              onPress: onOpenChange,
            },
            {
              children: t("buttons.confirm"),
              onPress: onQuit,
            },
          ],
        },
      }}
    />
  );
};
